import { SvgIcon } from '@mui/material';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { app } from 'router/routes';

const useCreateAssessmentDefBtn = () => {
    const navigate = useNavigate()

    const goCreateAssessmentDef = useCallback(() => {
        navigate(app.createAssessmentDef)
    }, [])

    const createAssessmentDefBtn = {
        label: "הוספת מבדק",
        color: "dark",
        variant: "solid",
        action: goCreateAssessmentDef,
        size: "small",
        icon: <SvgIcon fontSize='small' component={AddIcon} inheritViewBox />
    }

    return createAssessmentDefBtn
}


export default useCreateAssessmentDefBtn